/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */

export type SectionItemsElementModelContentType = typeof SectionItemsElementModelContentType[keyof typeof SectionItemsElementModelContentType];


export const SectionItemsElementModelContentType = {
  sectionItems: 'sectionItems',
} as const;
